// extracted by mini-css-extract-plugin
export default {"SignUp":"SignUp_SignUp__6o8N6","form":"SignUp_form__zFazD","form__group":"SignUp_form__group__7C6Xw","error":"SignUp_error__ksOvl"};